import { Step as ModelStep } from "@redotech/redo-model/return-flow";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import CancelIcon from "@redotech/redo-web/icon-old/octagon.svg";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export interface BlockState {
  message: string;
  customTitle?: string;
}

export const BLOCK = (
  Details: React.ComponentType<StepTypeDetailsProps<BlockState>>,
): StepType<BlockState, ModelStep.Block> => ({
  Details: (props: StepTypeDetailsProps<BlockState>) =>
    React.createElement(Details, props),
  customTitle(state) {
    return state.customTitle;
  },
  description(state) {
    return state.message;
  },
  downstream() {
    return [];
  },
  maxDownstream() {
    return 0;
  },
  empty: { message: "" },
  layout() {
    return BlockLayout.FULL;
  },
  stepDeleted(state) {
    return state;
  },
  title: "Block",
  valid(state) {
    return !!state.message;
  },
  fromModel(model) {
    return { customTitle: model.customTitle, message: model.message };
  },
  toModel(state) {
    return {
      customTitle: state.customTitle,
      type: ModelStep.BLOCK,
      message: state.message,
    };
  },
  Icon: CancelIcon,
  iconColor: "success",
});
